<template>
  <div class="no_found" :style="styleObject">
    <div class="text">{{text ? text : $t('txt.noFound')}}</div>
  </div>
</template>

<script>
export default {
  name: 'noFound',
  data () {
    return {
      styleObject: {}
    }
  },
  /**
   * 支持传 宽、高、字号、内容
   */
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    fontSize: {
      type: String,
      default: '12px'
    },
    text: {
      type: String
    },
  },
  created(){
    this.styleObject = {
      // 如果有百分号就用百分号，没有百分号就用px
      width: this.width.indexOf('%') === -1 ? this.width+'px': this.width,
      height: this.height.indexOf('%') === -1 ? this.height+'px': this.height,
      'font-size': this.fontSize+'px'
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'
.no_found
  display flex;
  justify-content center
  align-items center
  background-color #F4F4F4
  .text
    line-height 1
    font-size inherit
    color #D6D6D6
    text-align center
</style>




// WEBPACK FOOTER //
// src/components/base/noFound/noFound.vue